import { Controller } from 'react-hook-form';
import styled from '@emotion/styled';
import { usePalette } from 'src/hooks';
import { Checkbox, Typography } from 'src/components/atoms';
import { Flex } from 'src/components/layout';
import { FormCheckboxProps } from './utils';

const FormCheckboxContainer = styled.div`
  display: grid;
  grid-template-rows: min-content minmax(1.3rem, min-content);
  padding: 3px 0;
`;

export const FormCheckbox = ({
  control,
  name,
  description,
  checkboxProps,
  defaultValue,
  rules,
  isError,
  errorMsg,
  testId
}: FormCheckboxProps) => {
  const { text, error } = usePalette();

  return (
    <FormCheckboxContainer>
      <Flex>
        <Controller
          render={({ field }) => (
            <Checkbox
              sx={{ mr: 1, padding: '0.25rem' }}
              {...checkboxProps}
              data-testid={testId}
              onChange={e => field.onChange(e.target.checked)}
              checked={field.value}
            />
          )}
          name={name}
          defaultValue={defaultValue || false}
          control={control}
          rules={rules}
        />
        {typeof description === 'object' ? (
          { ...description }
        ) : (
          <Typography variant='body1' color={text.primary}>
            {description}
          </Typography>
        )}
      </Flex>
      {isError && (
        <Typography variant='body2' color={error.main} sx={{ ml: 2 }}>
          {errorMsg}
        </Typography>
      )}
    </FormCheckboxContainer>
  );
};
